import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AffiContrModel } from 'src/app/models/affiliatecontrol.model';
import { AffiliateControllService } from 'src/app/services/service.index';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';

declare function init_map();

@Component({
  selector: 'app-afficontroll',
  templateUrl: './afficontroll.component.html',
  styles: []
})
export class AfficontrollComponent implements OnInit {
  @ViewChild('searchGMaps') searchGMaps: ElementRef;

  tituloBoton = 'Ver Mapa';
  mostrarMapa = false;
  mostrarParentezco = false;
  mostrarParentezcoMod3 = false;
  mostrarTelefono = false;
  mostrarMail = false;
  valorParentezco = '';
  valorParentezcoOtro = '';
  valorTelefono = '';
  valorMail = '';
  sub: any;
  labelPregunta8 = '';
  verCampos = false;
  verCamposConyugue = false;
  verCampoOtro = false;
  


  affiContrModel: AffiContrModel = {
    afiNombre: '',
    afiApellido: '',
    afiDni: '',
    afiTelef: '',
    afiDireccion: '',
    afiMail: '',
    afiReferencias: '',
    afiCEParentesco: '',
    afiCETelefono: '',
    afiCEMail: '',
    afiCOTelefono: '',
    afiCOMail: '',
    afiPRParentesco: '',
    afiPRTelefono: '',
    afiPRMail: '',
    afiModelo: ''
  };

  constructor(public router: Router, private http: HttpClient, private SpinnerService: NgxSpinnerService,
    public affiliateService: AffiliateControllService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    init_map();

    this.sub = this.route
        .queryParams
        .subscribe(params => {
        // Defaults to 0 if no query param provided.
        //document.querySelector('#pptId').innerHTML = params.Id || '0';
        this.affiContrModel.afiModelo = params.modelo || params.Modelo || '1';
      });


      if (this.affiContrModel.afiModelo  == '1') {
        this.mostrarParentezco = true;
        this.mostrarTelefono = true;
        this.mostrarMail = true;
        this.labelPregunta8 = 'Datos y contactos de emergencia:';
      } else if (this.affiContrModel.afiModelo == '2') {
        this.mostrarParentezco = false;
        this.mostrarTelefono = true;
        this.mostrarMail = true;
        this.verCamposConyugue = true;
        this.labelPregunta8 = 'Contacto del cónyuge:';
        this.verCampos = false;
      } else if (this.affiContrModel.afiModelo == '3') {
        this.mostrarParentezcoMod3 = true;
        this.mostrarTelefono = true;
        this.mostrarMail = true;
        this.labelPregunta8 = 'Contacto del otro progenitor o tutor de su/s hijo/s:';
      }
      else {
        this.mostrarParentezco = true;
        this.mostrarTelefono = true;
        this.mostrarMail = true;
        this.labelPregunta8 = 'Datos y contactos de emergencia:';
      }
  }

  verMapa() {
    this.mostrarMapa = !this.mostrarMapa;
    if (this.tituloBoton === 'Ver Mapa') {
      this.tituloBoton = 'Ocultar';
    } else {
      this.tituloBoton = 'Ver Mapa';
    }
  }

  mostrarCampos(){
    if (this.valorParentezco != 'OTRO'){
      this.verCampos = true;
      this.verCampoOtro = false;
    }else {
      this.verCampoOtro = true;
      this.verCampos = true;
    } ;
  };

  isEmail(search:string) : boolean
  {
      let serchfind: boolean;
      var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      serchfind = regexp.test(search);
      return serchfind;
  }

  saveAffiliateDates(){
    this.SpinnerService.show();
    let bError = false;
    let sMensaje = '';

    if (this.searchGMaps.nativeElement.value !== '') {
      this.affiContrModel.afiDireccion = this.searchGMaps.nativeElement.value;
    }

    if (this.affiContrModel.afiNombre === '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar el campo Nombres';
      } else {
        sMensaje += ', Nombres';
      }
    }

    if (this.affiContrModel.afiApellido === '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar el campo Apellidos';
      } else {
        sMensaje += ', Apellidos';
      }
    }

    if (this.affiContrModel.afiDni === '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar el campo DNI';
      } else {
        sMensaje += ', DNI';
      }
    }

    if (this.affiContrModel.afiDireccion === '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar el campo Direccion';
      } else {
        sMensaje += ', Direccion';
      }
    }

    if (this.affiContrModel.afiTelef === '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar el campo Telefono';
      } else {
        sMensaje += ', Telefono';
      }
    }

    if (this.affiContrModel.afiMail === '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar el campo Mail';
      } else {
        sMensaje += ', Mail';
      }
    }
    
    if ( this.affiContrModel.afiModelo === '1' && this.valorMail === ''  || this.affiContrModel.afiModelo === '1'  && this.valorTelefono === '' || this.affiContrModel.afiModelo === '1' && this.valorParentezcoOtro === ''  ) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar los datos del contacto ';
      } else {
        sMensaje += ', Parentesco';
      }
    }

    if (this.affiContrModel.afiModelo === '3' && this.valorMail === '' || this.affiContrModel.afiModelo === '3' && this.valorTelefono === '' || this.affiContrModel.afiModelo === '3' && this.valorParentezco === '' ){
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar los datos del contacto ';
      } else {
        sMensaje += ', Parentesco';
      }
    }

    if (this.affiContrModel.afiModelo === '2' && this.valorMail === '' || this.affiContrModel.afiModelo === '2' && this.valorTelefono === '' ) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'Debe completar los datos del contacto ';
      } else {
        sMensaje += ', Datos de cónyuge';
      }
    }

    if (this.affiContrModel.afiTelef === this.valorTelefono && this.valorTelefono !== '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo Telefono de contacto ingresado no puede ser el mismo que posee el titular, por favor ingrese un telefono el cual nos permita comunicarnos con el contacto de emergencia ';
      } else {
        sMensaje += ', El campo Telefono de contacto ingresado no puede ser el mismo que posee el titular';
      }
    }

    if (this.affiContrModel.afiTelef !== '' && this.affiContrModel.afiTelef.length !== 10) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo Telefono debe tener 10 numeros';
      } else {
        sMensaje += ', El campo Telefono debe tener 10 numeros';
      }
    }

    if(this.affiContrModel.afiMail.toUpperCase() === this.valorMail.toUpperCase() &&  this.valorMail !== '') {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo Mail de contacto ingresado no puede ser el mismo que posee el titular, por favor ingrese un mail el cual nos permita comunicarnos con el contacto de emergencia ';
      } else {
        sMensaje += ', El campo Mail de contacto ingresado no puede ser el mismo que posee el titular ';
      }
    }
    if(this.valorMail !== '' && !this.isEmail(this.valorMail)) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo Mail de contacto ingresado no es valido';
      } else {
        sMensaje += ', El campo Mail de contacto no es valido';
      }
    }

    if(this.affiContrModel.afiMail !== '' && !this.isEmail(this.affiContrModel.afiMail)) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo Mail ingresado no es valido';
      } else {
        sMensaje += ', El campo Mail ingresado no es valido';
      }
    }

    if ( this.valorTelefono !== '' && this.valorTelefono.length !== 10) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo Telefono (Preg 8) debe tener 10 numeros';
      } else {
        sMensaje += ', El campo Telefono (Preg 8) debe tener 10 numeros';
      }
    }
    if (this.affiContrModel.afiDni !== '' && this.affiContrModel.afiDni.length !== 8) {
      bError = true;
      if (sMensaje.length == 0) {
        sMensaje = 'El campo DNI debe tener 8 numeros';
      } else {
        sMensaje += ', El campo DNI debe tener 8 numeros';
      }
    }

    if (bError) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        // tslint:disable-next-line: max-line-length
        text: sMensaje
      });
      this.SpinnerService.hide();
      return;
    }

    this.affiContrModel.afiCEParentesco = '';
    this.affiContrModel.afiCETelefono = '';
    this.affiContrModel.afiCEMail = '';
    this.affiContrModel.afiCOTelefono = '';
    this.affiContrModel.afiCOMail = '';
    this.affiContrModel.afiPRParentesco = '';
    this.affiContrModel.afiPRTelefono = '';
    this.affiContrModel.afiPRMail = '';

    if (this.affiContrModel.afiModelo == '1') {
      console.log('this.valorParentezco', this.valorParentezco);
      console.log('this.valorParentezcoOtro', this.valorParentezcoOtro);
      if (this.valorParentezco !== 'OTRO')
        this.affiContrModel.afiCEParentesco = this.valorParentezco;
      else
        this.affiContrModel.afiCEParentesco = this.valorParentezcoOtro;
      this.affiContrModel.afiCETelefono = this.valorTelefono;
      this.affiContrModel.afiCEMail = this.valorMail;

    } else if (this.affiContrModel.afiModelo == '2') {
      this.affiContrModel.afiCOTelefono = this.valorTelefono;
      this.affiContrModel.afiCOMail = this.valorMail;

    } else if (this.affiContrModel.afiModelo == '3') {
      if (this.valorParentezco !== 'OTRO')
        this.affiContrModel.afiPRParentesco = this.valorParentezco;
      else
        this.affiContrModel.afiPRParentesco = this.valorParentezcoOtro;
      this.affiContrModel.afiPRTelefono = this.valorTelefono;
      this.affiContrModel.afiPRMail = this.valorMail;
    }

    this.affiliateService.postAffiliateControl(this.affiContrModel)
      .subscribe( respSpr => {
        this.SpinnerService.hide();
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Su encuesta fue respondida con exito!!',
          showConfirmButton: false,
          timer: 3500
        });
    }, err => {
      this.SpinnerService.hide();
      Swal.fire({
        icon: 'error',
        title: 'Atención',
        // text: 'Se ha producido un error en el alta del Prospecto. Por favor intente más tarde.'
        text: err.error.Message
      });
    });
  }
}
